import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class AccommSupportReviewService {
  constructor(private http: HttpClient) { }

  getPsychometricReviewData(reviewDetailId: string, requestId: string) {
    return this.http.get(
      `/api/internalpsychometricreviewdata/getPsychometricreviewdata`,
      {
        responseType: "json",
        params: { review_detail_id: reviewDetailId, request_id: requestId },
        observe: "response"
      }
    );
  }

  updatePsychometricReviewData(data: any) {
    return this.http.put(
      `/api/internalpsychometricreviewdata/updatePsychometricreviewdata`,
      data,
      { observe: "response" }
    );
  }

  createPsychometricReviewData(data: any) {
    return this.http.put(
      `/api/internalpsychometricreviewdata/createPsychometricreviewdata`,
      data,
      { observe: "response" }
    );
  }

  getMBEReviewData(reviewDetailId: string, requestId: string) {
    return this.http.get(`/api/internalmbereviewdata/getMbereviewdata`, {
      responseType: "json",
      params: { review_detail_id: reviewDetailId, request_id: requestId },
      observe: "response"
    });
  }

  updateMBEReviewData(data: any) {
    return this.http.put(
      `/api/internalmbereviewdata/updateMbereviewdata`,
      data,
      { observe: "response" }
    );
  }

  createMBEReviewData(data: any) {
    return this.http.put(
      `/api/internalmbereviewdata/createMbereviewdata`,
      data,
      { observe: "response" }
    );
  }

  getLanguageReviewData(reviewDetailId: string, requestId: string) {
    return this.http.get(
      `/api/internallanguagereviewdata/getLanguagereviewdata`,
      {
        responseType: "json",
        params: { review_detail_id: reviewDetailId, request_id: requestId },
        observe: "response"
      }
    );
  }

  updateLanguageReviewData(data: any) {
    return this.http.put(
      `/api/internallanguagereviewdata/updateLanguagereviewdata`,
      data,
      { observe: "response" }
    );
  }

  createLanguageReviewData(data: any) {
    return this.http.put(
      `/api/internallanguagereviewdata/createLanguagereviewdata`,
      data,
      { observe: "response" }
    );
  }

  getChronicReviewData(reviewDetailId: string, requestId: string) {
    return this.http.get(
      `/api/internalchronicreviewdata/getChronicreviewdata`,
      {
        responseType: "json",
        params: { review_detail_id: reviewDetailId, request_id: requestId },
        observe: "response"
      }
    );
  }

  updateChronicReviewData(data: any) {
    return this.http.put(
      `/api/internalchronicreviewdata/updateChronicreviewdata`,
      data,
      { observe: "response" }
    );
  }

  createChronicReviewData(data: any) {
    return this.http.put(
      `/api/internalchronicreviewdata/createChronicreviewdata`,
      data,
      { observe: "response" }
    );
  }

  getADAReviewData(reviewDetailId: string, requestId: string) {
    return this.http.get(`/api/internaladareviewdata/getAdareviewdata`, {
      responseType: "json",
      params: { review_detail_id: reviewDetailId, request_id: requestId },
      observe: "response"
    });
  }

  updateADAReviewData(data: any) {
    return this.http.put(
      `/api/internaladareviewdata/updateAdareviewdata`,
      data,
      { observe: "response" }
    );
  }

  createADAReviewData(data: any) {
    return this.http.put(
      `/api/internaladareviewdata/createAdareviewdata`,
      data,
      { observe: "response" }
    );
  }

  getELEReviewData(reviewDetailId: string, requestId: string) {
    return this.http.get(`/api/internalelereviewdata/getElereviewdata`, {
      responseType: "json",
      params: { review_detail_id: reviewDetailId, request_id: requestId },
      observe: "response"
    });
  }

  updateELEReviewData(data: any) {
    return this.http.put(
      `/api/internalelereviewdata/updateElereviewdata`,
      data,
      { observe: "response" }
    );
  }

  createELEReviewData(data: any) {
    return this.http.put(
      `/api/internalelereviewdata/createElereviewdata`,
      data,
      { observe: "response" }
    );
  }

  getDecisions(reviewDetailId: string, requestId: string) {
    return this.http.get(`/api/internaldecisions/getDecisions`, {
      responseType: "json",
      params: { review_detail_id: reviewDetailId, request_id: requestId },
      observe: "response"
    });
  }

  getRequestComment(reviewDetailId: string, requestId: string) {
    return this.http.get(`/api/internalReviewDetail/getRequestComment`, {
      responseType: "json",
      params: { review_detail_id: reviewDetailId, request_id: requestId },
      observe: "response"
    });
  }

  updateRequestComment(data: any) {
    return this.http.put(
      `/api/internalReviewDetail/updateExternalComment`,
      data,
      { observe: "response" }
    );
  }

  createRequestComment(data: any) {
    return this.http.put(
      `/api/internalReviewDetail/createExternalComment`,
      data,
      { observe: "response" }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/services/accommsupportreview.service.ts